const TIME_STAMP_CLOSE = 'time_stamp_close';
const SECONDS_DIFFERENCE_LOGOUT = 2;

export default {
  initialize(){
    if (this.getTimeStamp() > 0){
      this.checkLogout();
    }

    setInterval(() => {
      this.write();
    }, 200);
  },
  getTimeStamp(){
    let timestamp = window.localStorage.getItem(TIME_STAMP_CLOSE);

    if (!timestamp){
      return 0;
    }

    return parseInt(timestamp);
  },
  getDate(){
    return parseInt(Date.now() / 1000);
  },
  checkLogout(){
    let diff = this.getDate() - this.getTimeStamp();
    //Si la diferencia es mayor
    if (diff > SECONDS_DIFFERENCE_LOGOUT){
      this.logout();
    }
  },
  write(){
    window.localStorage.setItem(TIME_STAMP_CLOSE, this.getDate());
  },
  logout(){
    window.localStorage.clear();
    window.location.reload();
  }


}
